import React, { Component } from "react";
import { Menu } from "semantic-ui-react";
import Link from "gatsby-link";
import { gql, graphql } from "react-apollo";
import { connect } from "react-redux";

class MainMenu extends Component {
  render() {
    const { handleItemClick, activeItem, position } = this.props;
    const { user } = this.props.data;
    return (
      <Menu.Menu position={position}>
        <Menu.Item
          name="home"
          as={Link}
          to={"/"}
          color="blue"
          active={activeItem === "home"}
          onClick={handleItemClick}
        />
        {!this.props.data.loading && user ? (
          <Menu.Item
            as={Link}
            to={"/cleanings"}
            name="My Cleanings"
            color="blue"
            active={activeItem === "My Cleanings"}
            onClick={handleItemClick}
          />
        ) : (
          <Menu.Item
            as={Link}
            to={"/booking"}
            name="Booking Page"
            color="blue"
            active={activeItem === "Booking Page"}
            onClick={handleItemClick}
          />
        )}
        <Menu.Item
          name="Free Cleanings"
          color="blue"
          as={Link}
          to={"/freecleanings"}
          active={activeItem === "freecleanings"}
          onClick={handleItemClick}
        />
        <Menu.Item
          name="Blog"
          color="blue"
          as={Link}
          to={"/"}
          active={activeItem === "Blog"}
          onClick={handleItemClick}
        />
        <Menu.Item
          name="Help"
          color="blue"
          as={Link}
          to={"/"}
          active={activeItem === "Help"}
          onClick={handleItemClick}
        />
        <Menu.Item
          name="Contact"
          color="blue"
          as={Link}
          to={"/"}
          active={activeItem === "Contact"}
          onClick={handleItemClick}
        />
        {!this.props.data.loading && user ? null : (
          <Menu.Item
            name="Login"
            color="blue"
            as={Link}
            to={"/login"}
            active={activeItem === "Login"}
            onClick={handleItemClick}
          />
        )}
      </Menu.Menu>
    );
  }
}

const myQuery = gql`
  query loginQuery {
    user: loggedInUser {
      id
      lastName
      firstName
      zip
      address
      city
      email
      phone
    }
  }
`;
const ConnectedMainMenu = graphql(myQuery, {
  options: {
    fetchPolicy: "cache-and-network"
  }
})(MainMenu);

const mapStateToProps = (state, ownProps) => {
  return {
    activeItem: state.global.activeItem
  };
};
export default connect(mapStateToProps)(ConnectedMainMenu);



// WEBPACK FOOTER //
// ./src/layouts/Menu.jsx